import { BaseResponse } from "../../../../../../../../types/api/api.types";
import { CreateAccountManuallyRequestData } from "../../../../../../../../types/api/endpoints/prospect/create.types";
import { PROSPECT_ENDPOINTS } from "../../../../../../../../utils/api/endpoints/prospectEndpoints";

const PREFIX = '[createAccountManuallyQuery]';

export const CREATE_ACCOUNT_MANUALLY_QUERY_KEY = 'CREATE_ACCOUNT_MANUALLY';

export const createAccountManuallyQuery = async (data: CreateAccountManuallyRequestData) => {
  console.log(PREFIX, `Requesting user account creation...`);

  const response = await PROSPECT_ENDPOINTS.createProspectManually(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as BaseResponse;
};